import UILayout from "components/layout/UILayout";
import MobileFixedFooter from "components/ui/MobileFixedFooter";
import { Heading } from "components/ui/Text";
import UILabel from "components/ui/UILabel";
import React from "react";
import styled from "styled-components";

const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 48px 24px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Body = styled(UILabel.Large)`
  color: color-mix(
    in srgb,
    ${(props) => props.theme.colors.text} 70%,
    ${(props) => props.theme.colors.uiBackground}
  );
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
`;

interface Props {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  footer?: React.ReactNode;
}

const Layout: React.FC<Props> = ({
  heading,
  subheading,
  children,
  actions,
  footer,
}) => (
  <Wrapper>
    {(heading || subheading) && (
      <Header>
        {heading && <Heading.H3 tag="h1">{heading}</Heading.H3>}
        {subheading && <Body>{subheading}</Body>}
      </Header>
    )}

    <Content>{children}</Content>

    {(actions || footer) && (
      <Footer>
        {actions && <MobileFixedFooter>{actions}</MobileFixedFooter>}

        {footer}
      </Footer>
    )}
  </Wrapper>
);

export default Layout;
